import {
 useContext
} from 'react';
import {
 Label
} from 'shared/components/ui/label';
import OELCodeEditor, {
 OELContext
} from '../components/OELCodeEditor';
import StepControllers from '../components/StepControllers';
import KeyValueEditor from '../components/KeyValueEditor';
import {
 V2OpCodeBuilderContext
} from '../V2OpCodeBuilderContext';
import {
 APIStep
} from 'builders/builderOpcode/jsonMode/types';
import ApiPicker from 'builders/destudio/opcode-editor/inline-pickers/ApiPicker';

const V2StepAPI = ({
    step,
    onStepChange,
    oelContext,
}: {
    step: APIStep;
    onStepChange: (step: APIStep) => void;
    oelContext: OELContext;
}) => {
    // ApiPicker manages its own list/loading state.
    useContext(V2OpCodeBuilderContext);
    const bareApiId = step.api_id || '';

    return (
        <div className="space-y-4">
            {/* API Selector — chip with Change / Edit / + New popups. */}
            <div className="space-y-1">
                <Label>API <span className="text-destructive">*</span></Label>
                <ApiPicker
                    apiId={bareApiId}
                    onChange={(api: any) => onStepChange({
                        ...step,
                        api_id: api?._id || ''
                    })}
                />
            </div>

            {/* API Inputs */}
            <div className="space-y-3 p-3 border rounded-md">
                <Label className="text-sm font-semibold">API Inputs (Optional)</Label>

                <OELCodeEditor
                    label="Body"
                    value={step.inputs?.body || ''}
                    onChange={(val) => onStepChange({
                        ...step,
                        inputs: {
 ...step.inputs,
body: val
}
                    })}
                    placeholder="Request body — type @ for references"
                    multiline
                    oelContext={oelContext}
                    templateMode={false}
                />

                <KeyValueEditor
                    label="Query Parameters"
                    value={step.inputs?.query_params || ''}
                    onChange={(val) => onStepChange({
                        ...step,
                        inputs: {
 ...step.inputs,
query_params: val
}
                    })}
                    placeholder="Add query parameter"
                />

                <KeyValueEditor
                    label="Path Parameters"
                    value={step.inputs?.path_params || ''}
                    onChange={(val) => onStepChange({
                        ...step,
                        inputs: {
 ...step.inputs,
path_params: val
}
                    })}
                    placeholder="Add path parameter"
                />

                <KeyValueEditor
                    label="Headers"
                    value={step.inputs?.headers || ''}
                    onChange={(val) => onStepChange({
                        ...step,
                        inputs: {
 ...step.inputs,
headers: val
}
                    })}
                    placeholder="Add header"
                />

                <OELCodeEditor
                    label="Auth"
                    value={step.inputs?.auth || ''}
                    onChange={(val) => onStepChange({
                        ...step,
                        inputs: {
 ...step.inputs,
auth: val
}
                    })}
                    placeholder="Auth — type @ for references"
                    oelContext={oelContext}
                    templateMode={false}
                />

                <OELCodeEditor
                    label="Request Timeout (s)"
                    value={String(step.inputs?.request_timeout_s ?? step.inputs?.timeout ?? '')}
                    onChange={(val) => {
                        // V2+: rename `timeout` -> `request_timeout_s`. Drop the
                        // legacy key on edit so we don't double-write.
                        const nextInputs = {
 ...step.inputs,
request_timeout_s: val
};
                        delete (nextInputs as any).timeout;
                        onStepChange({
 ...step,
inputs: nextInputs
});
                    }}
                    placeholder="Seconds (number or OEL)"
                    oelContext={oelContext}
                    templateMode={false}
                />
            </div>

            {/* Controllers */}
            <StepControllers
                when={step.when}
                forCtrl={step.for}
                repeatUntil={step.repeat_until}
                onWhenChange={(val) => onStepChange({
 ...step,
when: val
})}
                onForChange={(val) => onStepChange({
 ...step,
for: val
})}
                onRepeatUntilChange={(val) => onStepChange({
 ...step,
repeat_until: val
})}
                oelContext={oelContext}
            />
        </div>
    );
};

export default V2StepAPI;
